(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["main-product-info"] && !Shopify.designMode) return;
  try {
    (function () {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
      if (!btn) return;
      var wrap = btn.closest('.kneft-qty');
      var input = wrap && wrap.querySelector('.kneft-qty__input');
      if (!input) return;

      var step = parseFloat(input.step) || 1;
      var min = input.min !== '' ? parseFloat(input.min) : 1;
      var max = input.max !== '' ? parseFloat(input.max) : Infinity;
      var current = parseFloat(input.value) || min;

      var next = btn.hasAttribute('data-qty-plus') ? current + step : current - step;
      next = Math.min(max, Math.max(min, next));

      if (next !== current) {
        input.value = next;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
